import React from 'react';
import {
  AreaChart, Area, BarChart, Bar, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const COLORS = ['#F55D00','#FDBF50','#3B82F6','#10B981','#8B5CF6','#EF4444','#06B6D4','#84CC16'];

const Card = ({ title, children }) => (
  <div className="al-chart-card">
    <div className="al-chart-title">{title}</div>
    {children}
  </div>
);

/** Line/Area trend chart */
export const TrendChart = ({ title, data = [], dataKey = 'count', color = '#F55D00', xKey = 'date' }) => (
  <Card title={title}>
    <ResponsiveContainer width="100%" height={200}>
      <AreaChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        <defs>
          <linearGradient id={`grad-${dataKey}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%"  stopColor={color} stopOpacity={0.25} />
            <stop offset="95%" stopColor={color} stopOpacity={0}    />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey={xKey} tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip />
        <Area type="monotone" dataKey={dataKey} stroke={color} fill={`url(#grad-${dataKey})`} strokeWidth={2} dot={false} />
      </AreaChart>
    </ResponsiveContainer>
  </Card>
);

/** Grouped bar chart */
export const GroupedBarChart = ({ title, data = [], bars = [], xKey = 'date' }) => (
  <Card title={title}>
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey={xKey} tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        {bars.map((b, i) => (
          <Bar key={b.key} dataKey={b.key} name={b.label} fill={COLORS[i % COLORS.length]} radius={[3,3,0,0]} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  </Card>
);

/** Donut / pie chart */
export const DonutChart = ({ title, data = [], nameKey = 'name', valueKey = 'value' }) => (
  <Card title={title}>
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={data} cx="50%" cy="50%"
          innerRadius={55} outerRadius={80}
          dataKey={valueKey} nameKey={nameKey}
          paddingAngle={3}
        >
          {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
        </Pie>
        <Tooltip formatter={(v, n) => [v.toLocaleString(), n]} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
      </PieChart>
    </ResponsiveContainer>
  </Card>
);
